import React, {Component} from "react";
import {configSalesStructureAndComposition} from "./config";
import * as R from "ramda";
import {monthOptions, yearOptions} from "../config";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class SalesStructureAndCompositionReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
          month: null,
          year: null,
          dataTable: [],
          tableConfig: configSalesStructureAndComposition,
        };
    };

    componentDidMount = () => {
        let currentDate = new Date();
        this.setState((prevValue) => ({
            ...prevValue,
            // month: monthOptions.find(item => item.value === currentDate.getMonth()),
            month: monthOptions.find(
              (item) => item.value === currentDate.getMonth() + 1
            ),
            year: yearOptions.find(item => item.value === currentDate.getFullYear()),
        }));
    };

    constructTable = () => {
        return this.state.dataTable.map(item => {
            if (!R.isNil(item)) {
                return (
                    <div className="grid-1">
                    <SimpleDataTable
                        key={item.namaCabang}
                        title={item?.namaCabang}
                        data={item?.data}
                        columns={this.state.tableConfig}
                        options={{pagination: false, serverSide: false}}
                    />
                    </div>
                )
            }
            return <></>
        });
    };

    tranformResponse = (data) => {
        if(!data) return [];
        const transformed = data.map((item) => {
            const { dataSales = {}, dataCS={}, dataOffice={}, ...rest } = item;
            return {
                ...rest,
                data:[dataSales, dataCS, dataOffice],
            };
        }
        );
        return transformed;
    };

    fetchData = async () =>{
        try{
            this.props.handleTriggerLoading();
            let dataKodeCabang = this.props.search;
            if(this.props.isAllSelected){
              dataKodeCabang = this.props.dataCabang.map((item) => item.kodeCabang)
            }
            const res = await fetchDataAsync({
              asyncFn:
                Api.create("NAGAMAS_REPORT_DTO")
                  .getLaporanStrukturDanKomposisiJualPerCabang,
              setError: this.props.setError,
              menuName: "Dashboard Kacab Keatas - Laporan Struktur dan Komposisi Jual Per Cabang",
              args: {
                kodeCabang: dataKodeCabang,
                year: this.state.year?.value,
                month: this.state.month?.value,
                employeeIdTeamLeader: this.props.idLeader,
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
               this.setState(prevValue => ({
                ...prevValue,
                dataTable: this.tranformResponse(res.data.data),
               }))
            }
            this.props.handleTriggerLoading();
        }catch(e){
            this.props.handleTriggerLoading();
            console.log(e,'error')
        }
    }

    handleSearch = ()=>{
        this.fetchData()
    }

    handleChangeSearchValue = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    }

    componentDidUpdate(prevProps, prevState) { 
        if (!R.equals(prevProps.search, this.props.search)){
            this.fetchData();
        }
    } 

    render() {
        return (
            <>
                <FlexView style={{gap: "20px", alignItems: "center"}}>
                    <SimpleDDL
                        id="select_options_month"
                        box="search"
                        name="month"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Bulan"
                        menuPosition="fixed"
                        options={monthOptions}
                        value={this.state.month}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleDDL
                        id="select_options_year"
                        box="search"
                        name="year"
                        isClearable
                        containerclassname="width width-250px"
                        placeholder="Tahun"
                        menuPosition="fixed"
                        options={yearOptions}
                        value={this.state.year}
                        onChange={(value, {name}) => this.handleChangeSearchValue(name, value)}
                    />
                    <SimpleButton
                        styles={{marginBottom: "20px"}}
                        onClick={()=>this.handleSearch()}
                    >Cari</SimpleButton>
                </FlexView>
                {
                      <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px" style={{overflowX:"auto"}}>
                        {this.constructTable()}
                      </div>
                }
            </>
        );
    };
}

export default SalesStructureAndCompositionReport;